import { useContext, Component } from 'react';
import { Redirect } from 'react-router';
import Container from 'react-bootstrap/Container';
import Alert from 'react-bootstrap/Alert';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { ButtonWithDisabledTooltip } from '../components/ButtonWithDisabledTooltip';
import { AuthenticationContext } from '../msal/AuthenticationContext';
import { NotificationContext } from '../context/NotificationContext';
import { TenantContext } from '../context/TenantContext';
import * as apiCalls from '../logic/apiCalls';
import { urls } from '../logic/urls';

import sharedCss from './Shared.module.scss';

class DeviceLandingPageInternal extends Component {

    state = {
        deviceAdded: false,
        deviceDescription: '',
        addIsDone: false,
    }

    constructor(props) {
        super(props);

        // Build the description validation Regex.
        let nonPrintableCharStart = String.fromCharCode(0x00); // NULL char
        let nonPrintableCharEnd = String.fromCharCode(0x1F); // S7 char
        let delRegex = String.fromCharCode(0xF); // DEL char
        let backslashRegex = "\\\\"; // The parsing of the literal string will reduce this to 2 backslashes, the parsing of this string by the RegExp class will reduce it to a single literal backslash to be matched.
        let forwardslashRegex = "\\/"; 
        let bracketOpeningRegex = "\\["; 
        let bracketClosingRegex = "\\]"; 
        let quotationRegex = "\\\""; 
        let additionalCharsRegex = "!@#$%^&*()={};:";
        
        this.descriptionValidationRegex = new RegExp(`^[^${nonPrintableCharStart}-${nonPrintableCharEnd}${delRegex}${backslashRegex}${forwardslashRegex}${bracketOpeningRegex}${bracketClosingRegex}${quotationRegex}${additionalCharsRegex}]*$`);
    }

    executeAddDevice = async () => {
        try {
            console.log(`[executeAddDevice] Invoking the back-end API to add the device with reference ID ${this.props.match.params.deviceid}.`);

            await apiCalls.addDevice(this.props.authenticationContext, this.props.match.params.deviceid, this.state.deviceDescription, null, null);

            this.props.notificationContext.setNotification("Adding device.", `'${this.state.deviceDescription}' successfully added.`, 'success');
        }
        catch (err) {
            this.props.notificationContext.setNotification("Adding device.", `Error deleting '${this.state.deviceDescription}'. ${err.toDetailedMessage()}`, 'danger');                  
        }
     
        this.setState({
            addIsDone: true,
        });
    }

    handleDeviceDescriptionChanged = (e) => {
        const updatedDescription = e.target.value;

        if (updatedDescription.length > 0 && !this.descriptionValidationRegex.test(updatedDescription)) {
            return;
        }
                
        this.setState({
            deviceDescription: updatedDescription
        });
    }

    shouldAddContactButtonBeEnabled = () => {
        return this.state.deviceDescription.length > 0;
    }

    render () {
        const pageHeader = (
            <div className="page-header d-flex">
                <div className="p-4">
                    <img className={sharedCss.logo} src="./images/TeresaCare-Logo.png" alt="TeresaCare logo"/>
                </div>
            </div>
        );    

        if (this.state.addIsDone) {
            return <Redirect to={urls.device}/>
        }
        
        return (
            <Container>
                <div className={sharedCss.background}>
                    {pageHeader}

                    <div className="mx-3">
                        <h1>Device</h1>
                        <Form>
                            <Form.Group as={Row} controlId="formSubscriptionName">
                                <Form.Label column sm={2}>
                                    Device ID
                                </Form.Label>
                                <Col sm={4}>
                                    <Form.Control type="text" readOnly value={this.props.match.params.deviceid} />
                                </Col>                            
                            </Form.Group>
                            <Form.Group as={Row} controlId="formSubscriptionPlan">
                                <Form.Label column sm={2}>
                                    Description
                                </Form.Label>
                                <Col sm={4}>
                                    <Form.Control type="text" placeholder="Enter description" value={this.state.deviceDescription} autoComplete="off" onChange={this.handleDeviceDescriptionChanged} />
                                </Col>
                            </Form.Group>                            
                            <Alert className="mt-3" variant="info" style={{opacity: 1}}>
                                This device will be linked to your tenant '{this.props.tenantContext.tenantLabel}' ({this.props.tenantContext.tenantId}). Make sure your have enough licenses available.
                            </Alert>        
                        </Form>
                        <ButtonWithDisabledTooltip color='primary' className='mb-3' disabled={!this.shouldAddContactButtonBeEnabled()} disabledTooltip="Fill in description" onClick={this.executeAddDevice}>Add Device</ButtonWithDisabledTooltip>
                    </div>
                </div>
            </Container>       
        );
    }
}


// Wrap the component so that multiple contexts are available via the props.
export const DeviceLandingPage = (props) => {
    const authenticationContext = useContext(AuthenticationContext);
    const notificationContext = useContext(NotificationContext);
    const tenantContext = useContext(TenantContext);
  
    return (
        <DeviceLandingPageInternal authenticationContext={authenticationContext} notificationContext={notificationContext} tenantContext={tenantContext} {...props}/>
    )
}


